import { createAction, props } from '@ngrx/store';
import { NewsResponse, SetNewsContentSeenResponse, SetNewsSeenFlagResponse, NewsTabType } from './news.models';

export const loadNews = createAction('[News] Load News', props<{ language: string }>());

export const loadNewsSuccess = createAction('[News] Load News Success', props<{ news: NewsResponse }>());

export const loadNewsFailure = createAction('[News] Load News Failure', props<{ error: any }>());

export const setNewsSeenFlag = createAction('[News] Set News Seen Flag', props<{ newsType: NewsTabType }>());

export const setNewsSeenFlagSuccess = createAction(
  '[News] Set News Seen Flag Success',
  props<{ response: SetNewsSeenFlagResponse }>(),
);

export const setNewsSeenFlagFailure = createAction('[News] Set News Seen Flag Failure', props<{ error: any }>());

export const setNewsContentSeen = createAction('[News] Set News Content Seen', props<{ id: number }>());

export const setNewsContentSeenSuccess = createAction(
  '[News] Set News Content Seen Success',
  props<{ response: SetNewsContentSeenResponse }>(),
);

export const setNewsContentSeenFailure = createAction('[News] Set News Content Seen Failure', props<{ error: any }>());
